// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  skillId: __t.string().primaryKey().name("skill_id"),
  playerId: __t.string().name("player_id"),
  matchId: __t.string().name("match_id"),
  unitId: __t.string().name("unit_id"),
  ordinal: __t.u32(),
  skillName: __t.string().name("skill_name"),
});
